import { writable } from "svelte/store";
import AuthState from "../Auth/Enums/AuthState";

class OAuthConfiguration {
	constructor(type, appId, redirectUrl) {
		this.type = type;
		this.appId = appId;
		this.redirectUrl = redirectUrl;

		this.authState = writable(AuthState.LOGGED_OUT);
		this.error = writable("");
		this.token = {
			username: writable(""),
			access: writable(""),
			refresh: writable(""),
			expires: writable(0)
		};
	}
}
export default OAuthConfiguration;
